<div>
  For bank account and payment matters, contact <a href="mailto:{{companyBranding?.financeEmail}}">{{companyBranding?.financeEmail}}</a>
</div>